import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, Image, TextInput } from '../../../types'

@Injectable({ providedIn: 'root' })
export class InfographicSlideConverter extends CmsConverterService<InfographicSlideData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_image_alternative_text?.value
    const lazyLoad = formData?.st_image_lazy_loading?.value
    return {
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
      imageMobile: CmsConverterService.mapImage(formData.st_image_reference_mobil, lazyLoad, altText, title),
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
    }
  }
}

export const INFOGRAPHIC_SLIDE_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, InfographicSlideData>>('InfographicSlideConverter')

export interface InfographicSlideData extends ConvertedComponentData {
  headline: TextInput;
  text: TextInput;
  image: Image;
  imageMobile: Image;
}
